import * as themes from './themes'
import * as audioPlayer from './audioPlayer'
import * as recent from './recent'
import * as favorite from './favorite'

export default { themes, favorite, audioPlayer, recent }
